import { z } from 'zod'

const dateString = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Date must be YYYY-MM-DD')

export const stockAddFormSchema = z
  .object({
    company_id: z.string().min(1, 'Company is required'),
    stock_class: z.string().min(1, 'Stock class is required'),
    share_count: z
      .string()
      .min(1, 'Share count is required')
      .refine((v) => Number(v) > 0, 'Share count must be > 0'),
    issued_date: dateString,
    effective_date: dateString,
    /** Angular defaults radios to `''` until user selects — same as `Validators.required`. */
    generate_letter: z
      .string()
      .refine((v) => v === '0' || v === '1', { message: 'Generate Letter is required' }),
    generate_email: z
      .string()
      .refine((v) => v === '0' || v === '1', { message: 'Generate Email is required' }),
    /** Match Angular: when true, the corresponding date can be edited manually. */
    issued_override: z.boolean(),
    effective_override: z.boolean(),
    upload_certificate: z.enum(['0', '1']),
    certificate_name: z.string(),
  })
  .refine(
    (v) => v.upload_certificate === '0' || v.certificate_name.length > 0,
    { message: 'Certificate file is required when "Upload Certificate" is Yes', path: ['certificate_name'] },
  )

export type StockAddFormValues = z.infer<typeof stockAddFormSchema>

export const stockDateEditSchema = z.object({
  effective_date: dateString,
  issued_date: dateString,
})

export type StockDateEditValues = z.infer<typeof stockDateEditSchema>
